import { useState, type FormEvent } from 'react'
import { ApiError } from '../lib/api'
import { useAuth } from '../lib/auth'

export default function Login() {
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [totp, setTotp] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [needsTotp, setNeedsTotp] = useState(false)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(email, password, totp || undefined)
    } catch (err) {
      const apiError = err instanceof ApiError ? err : null
      // Reveal the authenticator field only once the password has been accepted, so the form
      // does not imply an account exists before credentials are checked.
      if (apiError?.reasonCode === 'invalid_totp') setNeedsTotp(true)
      setError(apiError?.message ?? 'Sign-in failed. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-head">
          <div className="brand-mark">SG</div>
          <h1 style={{ fontSize: 21 }}>SMS Gateway</h1>
          <div className="muted small" style={{ marginTop: 5 }}>
            Sign in to the operations console
          </div>
        </div>

        {error && (
          <div className="banner danger" role="alert">
            {error}
          </div>
        )}

        <label className="field">
          <span className="field-label">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="username"
          />
        </label>

        <label className="field">
          <span className="field-label">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </label>

        {needsTotp && (
          <label className="field">
            <span className="field-label">Authenticator code</span>
            <input
              type="text"
              value={totp}
              onChange={(e) => setTotp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="000000"
              className="mono"
              autoFocus
            />
          </label>
        )}

        <button className="btn primary" type="submit" style={{ width: '100%', marginTop: 6 }} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
